<template>
  <div>
    <div class="columns is-vcentered is-gapless has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom">
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="tab = 'access'"
            :class="{'is-active': tab === 'access'}"
          >
            <span class="has-text-weight-normal">{{accesses.length}} Mandat<span v-if="accesses.length > 1">s</span> ouvert<span v-if="accesses.length > 1">s</span></span>
          </a>
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
            @click="tab = 'create'"
            :class="{'is-active': tab === 'create'}"
          >
            <span class="has-text-weight-normal">Création mandat programme</span>
          </a>
        </div>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a @click="$emit('reloadAccess')" class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey">
          <span class="icon is-small"><i class="fas fa-sync"></i></span>
        </a>
      </div>
    </div>
    <div v-if="tab === 'access' && !loading">
      <table class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom is-border-bottom is-border-top">
        <thead>
          <tr class="is-size-6">
            <th></th>
            <th>Société</th>
            <th>Mandat</th>
            <th v-if="displayRemuneration">Rémunération</th>
          </tr>
        </thead>
        <promoteur-access-item class="is-size-5 has-text-text"
                     v-for="(a, i) in companiesWrappers"
                     first-key="company"
                     :key="i"
                     :promoteur="promoteur"
                     :source="a"
                     :loading-access="loadingAccess"
                     :selected-access="selectedAccess"
                     @addAccess="addAccess"
                     @deleteAccess="deletePromoteurAccess"
                     @updateAccess="updateAccess"
                     @selectedAccess="val => selectedAccess = val">
        </promoteur-access-item>
      </table>
    </div>
    <div v-if="tab === 'create'">
      <access-form @submit="createAccess" :loading="loading" ref="accessForm"
                   :source-promoteur="promoteur"></access-form>
      <div class="column is-12 is-marginless is-paddingless is-border-top columns">
        <div class="column is-6">
          <a @click="tab = 'access'" class="button is-white is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-6">
          <button @click="askSubmit" class="button is-success is-uppercase is-fullwidth has-text-white"
                  :disabled="loading" :class="{'is-loading':loading}">
            <span v-if="!loading">Enregistrer</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { sortBy } from 'lodash'
  import { MultiSelection } from '@/mixins'
  import { mapGetters } from 'vuex'
  import AccessForm from '@/components/access/AccessForm'
  import PromoteurAccessItem from './PromoteurAccessItem'

  export default {
    name: 'PromoteurAccessPanel',
    mixins: [MultiSelection],
    components: {AccessForm, PromoteurAccessItem},
    data () {
      return {
        tab: 'access',
        loadingAccess: false,
        selectedAccess: null
      }
    },
    props: {
      access: {
        type: Array,
        required: true
      },
      promoteur: {
        type: Object,
        required: true
      },
      companies: Array,
      loading: Boolean
    },
    computed: {
      ...mapGetters(['displayRemuneration']),
      accesses () {
        return sortBy(this.access, x => x.company_name.toLowerCase())
      },
      promoteurPk () {
        return this.promoteur.pk
      },
      companiesWrappers () {
        let wrappers = []
        this.companies.forEach((company, i) => {
          let wrapper = {
            pk: 'company' + i,
            company: company.pk,
            company_name: company.name,
            remuneration: null,
            no_access: true
          }

          let access = this.accesses.find(x => {
            return x.company === company.pk
          })

          if (access) {
            wrapper.pk = access.pk
            wrapper.no_access = false
            if (access.remuneration) {
              wrapper.remuneration = access.remuneration
            }
          }
          wrappers.push(wrapper)
        })
        return wrappers
      }
    },
    methods: {
      askSubmit () {
        this.$refs.accessForm.submit()
      },
      createAccess (access) {
        this.$notify({
          type: 'is-info',
          text: 'Création des mandats en cours...'
        })
        this.simulateSubmit = false
        this.loadingAccess = true
        this.$api.accessService.post(access).then(res => {
          this.tab = 'access'
          this.loadingAccess = false
          this.selectedAccess = null
          // this.$emit('reloadAccess')
        }).catch(() => {
          this.loadingAccess = false
          this.selectedAccess = null
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du mandat.'
          })
        })
      },
      updateAccess (access) {
        this.loadingAccess = true
        let newAccess = {
          pk: access.pk,
          remuneration: access.remuneration,
          end_date: access.end_date,
          start_date: access.start_date,
          use_company_remuneration: access.use_company_remuneration,
          use_program_remuneration: access.use_program_remuneration
        }
        this.$api.accessService.patchPromoteurAccess(newAccess.pk, newAccess).then(r => {
          this.loadingAccess = false
          this.selectedAccess = null
          this.$notify({
            type: 'is-success',
            text: 'Le mandat à été mis à jour.'
          })
          this.$emit('reloadAccess')
        }).catch(() => {
          this.loadingAccess = false
          this.selectedAccess = null
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du mandat.'
          })
        })
      },
      async addAccess (access) {
        let data = {
          use_company_remuneration: true,
          companies: [access.company],
          promoteurs: [this.promoteurPk]
        }
        let res = await this.$api.accessService.postPromoteurAccess(data)
        if (res) {
          this.$notify({
            type: 'is-success',
            text: 'Mandat créé.'
          })
          this.$nextTick(() => {
            this.$emit('reloadAccess')
          })
        }
      },
      deletePromoteurAccess (accessPk) {
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce mandat ?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.$api.accessService.deletePromoteurAccess(accessPk).then(() => {
              // this.$emit('reloadAccess')
              this.$notify({
                type: 'is-success',
                text: `Mandat supprimé.`
              })
              this.$emit('reloadAccess')
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurAccessPanel.vue